const NotificationContentRead = ({ textContent, header, ariaLabel }) => {
  return (
    <div aria-label={ariaLabel}>
      <p className="notification-content-label">{header}</p>
      <p className="notification-content-read"> {textContent || '-'} </p>
    </div>
  );
};

export { NotificationContentRead };
